import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en/translation.json";
import enMessage from "./en/message.json";
import jp from "./jp/translation.json";
import jpMessage from "./jp/message.json";
import cn from "./cn/translation.json";
import cnMessage from "./cn/message.json";
import kr from "./kr/translation.json";
import krMessage from "./kr/message.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en, message: enMessage },
      jp: { translation: jp, message: jpMessage },
      cn: { translation: cn, message: cnMessage },
      kr: { translation: kr, message: krMessage }
    },
    lng: localStorage.getItem("i18nextLng") || "en",
    fallbackLng: "en",
    ns: ["translation", "message"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "sessionStorage",
        "navigator",
        "htmlTag"
      ],
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",
      lookupSessionStorage: "i18nextLng",

      // Cache user language
      caches: ["localStorage"],
      excludeCacheFor: ["cimode"]
    }
  });

export default i18n;
